import { getStoredData } from './store';

export interface Product {
  id: number;
  name: string;
  category: 'alta-costura' | 'capsula';
  collection: string;
  price: number;
  description: string;
  details: string[];
  materials: string;
  measurements: string;
  image: string;
  images: string[];
  availability: 'disponible' | 'encargo' | 'agotado';
  deliveryTime: string;
  stock: number;
}

export const products: Product[] = [
  {
    id: 101,
    name: 'Vestido de Gala "Nocturna"',
    category: 'alta-costura',
    collection: 'Noches de Gala',
    price: 4800,
    description: 'Vestido de gala en seda natural italiana con encaje chantilly francés y bordado a mano en detalles del escote. Cada pieza es única y confeccionada a medida en nuestro atelier de Barcelona.',
    details: [
      'Confección 100% a medida en atelier Barcelona',
      'Seda natural italiana con certificado de origen',
      'Encaje chantilly francés auténtico',
      'Bordado artesanal a mano en escote',
      'Forro en seda de seda habotai',
      '3 sesiones de prueba incluidas',
    ],
    materials: 'Seda natural italiana 100%, encaje chantilly francés, forro seda habotai, cierre invisible a mano.',
    measurements: 'Cada prenda se confecciona a medida exacta del cliente. Incluye 3 sesiones de prueba para ajustes perfectos.',
    image: 'https://readdy.ai/api/search-image?query=elegant-haute-couture-evening-gown-full-length-black-silk-lace-french-chantilly-embroidered-neckline-luxury-fashion-editorial-photography-dark-background-spotlight-grain-texture-cinematic-portrait-orientation',
    images: [
      'https://readdy.ai/api/search-image?query=elegant-haute-couture-evening-gown-full-length-black-silk-lace-french-chantilly-embroidered-neckline-luxury-fashion-editorial-photography-dark-background-spotlight-grain-texture-cinematic-portrait-orientation',
      'https://readdy.ai/api/search-image?query=haute-couture-evening-gown-back-view-silk-lace-train-flowing-elegant-dark-background-dramatic-lighting-luxury-fashion-editorial-grain-texture-cinematic-portrait-orientation',
      'https://readdy.ai/api/search-image?query=close-up-haute-couture-dress-embroidered-lace-neckline-detail-gold-thread-handmade-beading-luxury-textile-art-dark-background-editorial-photography-soft-lighting-portrait-orientation',
    ],
    availability: 'encargo',
    deliveryTime: '4-6 semanas',
    stock: 0,
  },
  {
    id: 102,
    name: 'Chaqueta Bordada "Oro Antiguo"',
    category: 'alta-costura',
    collection: 'Orígenes Dorados',
    price: 3200,
    description: 'Chaqueta de corte estructurado en brocado italiano con bordado a mano en hilo de oro. Inspirada en los ateliers de París y Roma, esta pieza es un statement de lujo artesanal contemporáneo.',
    details: [
      'Confección 100% a medida en atelier Barcelona',
      'Brocado italiano de doble ancho',
      'Bordado a mano en hilo de oro auténtico',
      'Forro en seda natural',
      'Botones forrados a mano',
      '2 sesiones de prueba incluidas',
    ],
    materials: 'Brocado italiano, hilo de oro para bordado, forro seda natural 100%, entretela de lino natural.',
    measurements: 'Cada prenda se confecciona a medida exacta del cliente. Incluye 2 sesiones de prueba para ajustes perfectos.',
    image: 'https://readdy.ai/api/search-image?query=haute-couture-jacket-gold-embroidery-baroque-pattern-rich-brocade-fabric-black-background-luxury-fashion-editorial-photography-soft-spotlight-grain-texture-cinematic-portrait-orientation',
    images: [
      'https://readdy.ai/api/search-image?query=haute-couture-jacket-gold-embroidery-baroque-pattern-rich-brocade-fabric-black-background-luxury-fashion-editorial-photography-soft-spotlight-grain-texture-cinematic-portrait-orientation',
      'https://readdy.ai/api/search-image?query=close-up-gold-embroidery-detail-on-black-velvet-fabric-luxury-handcraft-haute-couture-artisanal-beading-dark-background-editorial-photography-soft-lighting-portrait-orientation',
      'https://readdy.ai/api/search-image?query=elegant-brocade-fabric-texture-rich-golden-pattern-luxury-textile-close-up-dark-background-haute-couture-material-editorial-photography-soft-lighting-portrait-orientation',
    ],
    availability: 'encargo',
    deliveryTime: '3-4 semanas',
    stock: 0,
  },
  {
    id: 103,
    name: 'Vestido de Seda Pintada "Jardín Secreto"',
    category: 'alta-costura',
    collection: 'Seda Pintada',
    price: 5600,
    description: 'Vestido en seda natural pintada a mano con técnica premiada internacionalmente. Cada prenda es una obra de arte irrepetible que combina la tradición textil con la expresión pictórica contemporánea.',
    details: [
      'Confección 100% a medida en atelier Barcelona',
      'Seda natural pintada a mano por Anthony Sánchez',
      'Técnica premiada internacionalmente',
      'Forro en seda habotai',
      'Edición única — cada pieza es irrepetible',
      'Certificado de autenticidad incluido',
    ],
    materials: 'Seda natural 100% pintada a mano con pigmentos textiles especiales, forro seda habotai.',
    measurements: 'Cada prenda se confecciona a medida exacta del cliente. Incluye 3 sesiones de prueba.',
    image: 'https://readdy.ai/api/search-image?query=hand-painted-silk-dress-artistic-watercolor-flowers-elegant-haute-couture-gown-flowing-fabric-soft-natural-lighting-minimal-background-luxury-fashion-editorial-photography-portrait-orientation',
    images: [
      'https://readdy.ai/api/search-image?query=hand-painted-silk-dress-artistic-watercolor-flowers-elegant-haute-couture-gown-flowing-fabric-soft-natural-lighting-minimal-background-luxury-fashion-editorial-photography-portrait-orientation',
      'https://readdy.ai/api/search-image?query=close-up-hand-painted-silk-fabric-detail-artistic-brush-strokes-watercolor-texture-luxury-haute-couture-material-soft-lighting-editorial-photography-portrait-orientation',
      'https://readdy.ai/api/search-image?query=elegant-hand-painted-silk-dress-draping-flowing-movement-artistic-fashion-luxury-couture-soft-lighting-minimal-background-editorial-photography-portrait-orientation',
    ],
    availability: 'encargo',
    deliveryTime: '6-8 semanas',
    stock: 0,
  },
  {
    id: 201,
    name: 'Blusa Seda "Básica de Lujo"',
    category: 'capsula',
    collection: 'Cápsula Essential',
    price: 290,
    description: 'Blusa en seda de crepe de alta calidad, entallada con elegancia discreta. El básico de lujo que eleva cualquier look diario con la calidad artesanal de Anthony Sánchez.',
    details: [
      'Tallas disponibles: XS, S, M, L',
      'Seda de crepe de alta calidad',
      'Acabado artesanal con costuras francesas',
      'Disponible en negro, blanco, champagne',
      'Lavado en seco recomendado',
    ],
    materials: 'Seda de crepe 100%, botones nácar, forro parcial en algodón egipcio.',
    measurements: 'Tallas estandarizadas XS-L. Tabla de medidas detallada disponible. Ajustes básicos incluidos.',
    image: 'https://readdy.ai/api/search-image?query=elegant-silk-crepe-blouse-luxury-basics-minimalist-style-champagne-color-soft-lighting-editorial-photography-clean-background-fashion-elegant-sophisticated-portrait-orientation',
    images: [
      'https://readdy.ai/api/search-image?query=elegant-silk-crepe-blouse-luxury-basics-minimalist-style-champagne-color-soft-lighting-editorial-photography-clean-background-fashion-elegant-sophisticated-portrait-orientation',
      'https://readdy.ai/api/search-image?query=elegant-silk-crepe-blouse-luxury-basics-minimalist-style-black-color-soft-lighting-editorial-photography-clean-background-fashion-elegant-sophisticated-portrait-orientation',
    ],
    availability: 'disponible',
    deliveryTime: '3-5 días laborables',
    stock: 12,
  },
  {
    id: 202,
    name: 'Falda Midi "Estructura"',
    category: 'capsula',
    collection: 'Cápsula Essential',
    price: 340,
    description: 'Falda midi con estructura sartorial en lana virgen italiana. Corte estructurado que mantiene la silueta con elegancia discreta, perfecta para el día a día con sofisticación.',
    details: [
      'Tallas disponibles: XS, S, M, L, XL',
      'Lana virgen italiana',
      'Forro en viscosa natural',
      'Disponible en negro, gris marengo, camel',
      'Lavado en seco recomendado',
    ],
    materials: 'Lana virgen italiana 100%, forro viscosa natural, cierre invisible.',
    measurements: 'Tallas estandarizadas XS-XL. Tabla de medidas detallada disponible. Ajustes básicos incluidos.',
    image: 'https://readdy.ai/api/search-image?query=elegant-structured-midi-skirt-italian-virgin-wool-black-color-sartorial-cut-minimalist-style-luxury-fashion-editorial-photography-clean-background-sophisticated-portrait-orientation',
    images: [
      'https://readdy.ai/api/search-image?query=elegant-structured-midi-skirt-italian-virgin-wool-black-color-sartorial-cut-minimalist-style-luxury-fashion-editorial-photography-clean-background-sophisticated-portrait-orientation',
      'https://readdy.ai/api/search-image?query=elegant-structured-midi-skirt-italian-virgin-wool-grey-melange-color-sartorial-cut-minimalist-style-luxury-fashion-editorial-photography-clean-background-portrait-orientation',
    ],
    availability: 'disponible',
    deliveryTime: '3-5 días laborables',
    stock: 8,
  },
  {
    id: 203,
    name: 'Cárdigan Cachemira "Suavidad"',
    category: 'capsula',
    collection: 'Cápsula Essential',
    price: 450,
    description: 'Cárdigan en cachemira mongola de primera calidad. Suavidad extrema con corte clásico atemporal. Un básico de lujo que durará décadas con el cuidado adecuado.',
    details: [
      'Tallas disponibles: S, M, L',
      'Cachemira mongola 100% de primera calidad',
      'Tejido artesanal en taller especializado',
      'Disponible en camel, gris perla, negro',
      'Lavado en seco o manual recomendado',
    ],
    materials: 'Cachemira mongola 100%, botones madera natural, acabado a mano.',
    measurements: 'Tallas estandarizadas S-L. Corte ligeramente oversized para mayor confort.',
    image: 'https://readdy.ai/api/search-image?query=luxury-cashmere-cardigan-camel-color-mongolian-cashmere-knitwear-soft-texture-elegant-minimalist-style-editorial-photography-clean-background-warm-lighting-sophisticated-portrait-orientation',
    images: [
      'https://readdy.ai/api/search-image?query=luxury-cashmere-cardigan-camel-color-mongolian-cashmere-knitwear-soft-texture-elegant-minimalist-style-editorial-photography-clean-background-warm-lighting-sophisticated-portrait-orientation',
      'https://readdy.ai/api/search-image?query=luxury-cashmere-cardigan-grey-pearl-color-mongolian-cashmere-knitwear-soft-texture-elegant-minimalist-style-editorial-photography-clean-background-sophisticated-portrait-orientation',
    ],
    availability: 'disponible',
    deliveryTime: '3-5 días laborables',
    stock: 5,
  },
  {
    id: 301,
    name: 'Vestido de Novia "Eternidad"',
    category: 'alta-costura',
    collection: 'Velo Nupcial',
    price: 7200,
    description: 'Vestido de novia artesanal con encaje chantilly francés y tul francés de la mejor calidad. Bordados personalizados y un diseño que captura la esencia del día más especial.',
    details: [
      'Confección 100% a medida en atelier Barcelona',
      'Encaje chantilly francés auténtico',
      'Tul francés de alta calidad',
      'Bordados personalizados a mano',
      '4 sesiones de prueba incluidas',
      'Incluye velo a juego',
    ],
    materials: 'Encaje chantilly francés, tul francés, forro seda natural, bordados a mano.',
    measurements: 'Cada prenda se confecciona a medida exacta del cliente. Incluye 4 sesiones de prueba.',
    image: 'https://readdy.ai/api/search-image?query=elegant-haute-couture-wedding-dress-bridal-gown-lace-veil-chantilly-embroidery-soft-white-lighting-minimal-background-luxury-fashion-editorial-photography-grain-texture-portrait-orientation',
    images: [
      'https://readdy.ai/api/search-image?query=elegant-haute-couture-wedding-dress-bridal-gown-lace-veil-chantilly-embroidery-soft-white-lighting-minimal-background-luxury-fashion-editorial-photography-grain-texture-portrait-orientation',
      'https://readdy.ai/api/search-image?query=close-up-chantilly-lace-detail-wedding-dress-embroidery-pearls-beading-soft-white-lighting-luxury-bridal-haute-couture-editorial-photography-portrait-orientation',
      'https://readdy.ai/api/search-image?query=elegant-bridal-veil-tulle-lace-detail-flowing-soft-lighting-white-background-luxury-wedding-haute-couture-editorial-photography-grain-texture-portrait-orientation',
    ],
    availability: 'encargo',
    deliveryTime: '8-12 semanas',
    stock: 0,
  },
  {
    id: 302,
    name: 'Pantalón Sastre "Perfect Fit"',
    category: 'capsula',
    collection: 'Cápsula Essential',
    price: 380,
    description: 'Pantalón de sastre en lana virgen italiana con corte perfectamente estructurado. La elegancia del tailored tradicional con el confort del día a día moderno.',
    details: [
      'Tallas disponibles: XS, S, M, L, XL',
      'Lana virgen italiana',
      'Corte sastre con pinzas frontales',
      'Disponible en negro, gris, navy',
      'Lavado en seco recomendado',
    ],
    materials: 'Lana virgen italiana 100%, forro acetato, cierre cremallera YKK, botón corozo.',
    measurements: 'Tallas estandarizadas XS-XL. Tabla de medidas detallada. Ajustes básicos incluidos.',
    image: 'https://readdy.ai/api/search-image?query=elegant-tailored-trousers-italian-virgin-wool-black-color-structured-cut-sartorial-style-minimalist-luxury-fashion-editorial-photography-clean-background-sophisticated-portrait-orientation',
    images: [
      'https://readdy.ai/api/search-image?query=elegant-tailored-trousers-italian-virgin-wool-black-color-structured-cut-sartorial-style-minimalist-luxury-fashion-editorial-photography-clean-background-sophisticated-portrait-orientation',
      'https://readdy.ai/api/search-image?query=elegant-tailored-trousers-italian-virgin-wool-navy-color-structured-cut-sartorial-style-minimalist-luxury-fashion-editorial-photography-clean-background-sophisticated-portrait-orientation',
    ],
    availability: 'disponible',
    deliveryTime: '3-5 días laborables',
    stock: 15,
  },
];

export const getProducts = (): Product[] => getStoredData<Product[]>('admin_products', products);